import { render, staticRenderFns } from "./CambioActividadEconomica.vue?vue&type=template&id=65c506ee&"
import script from "./CambioActividadEconomica.vue?vue&type=script&lang=ts&"
export * from "./CambioActividadEconomica.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports